export const messages = {
    en: {
        businessUnit: "Business Unit",
        normalMortality: "Normal Mortality",
        lines: "Lines",
        cause: "Primary Cause",
        causes: "Causes",
        reasons: "Reasons",
        requestBy: "Requested By",
        requestDate: "Request Date",
        view: "View",
        approvalStatus: "Status",
        approvalNotes: "Approval Notes",
        approvals: "Approvals",
        currency: "Currencies",
        approvers: "Approvers",
        bookingRegion: "Booking Region",
        filter: "Filter",
        apply: "Apply",
        bookingsOrderNumber: "Bookings Order Number",
        order: {
            gender: 'Gender',
            line: 'Line'
        },
        approver: {
            name: 'Name'
        },
        approvalStatus: {
            title: "Approval Status",
            status: 'Status'
        },
        customer: "Customer",
        bookingsOrder: "Bookings Order",
        or: "Or",
        priceperchick: "Price Per Chick"
    },
    es: {
        businessUnit: "Business Unit",
        lines: "Líneas",
        cause: "Primary Cause",
        causes: "Causes",
        reasons: "Reasons",
        requestBy: "Requested By",
        requestDate: "Request Date",
        view: "View",
        approvalStatus: "Status",
        approvalNotes: "Approval Notes",
        approvals: "Approvals",
        approvalType: "Approval Type",
        approvers: "Approvers",
        bookingRegion: "Booking Region",
        currency: "Currency",
        filter: "Filtrar",
        apply: "Aplicar",
        bookingsOrderNumber: "Número de pedido de reservas",
        order: {
            gender: 'Género',
            line: 'Línea'
        },
        approver: {
            name: 'Name'
        },
        approvalType: {
            status: 'Status'
        },
        customer: "Cliente",
        bookingsOrder: "Orden de reservas",
        or: "O",
        priceperchick: "Precio por pollito"
    },
    pt: {
        
    },
    nl: {

    }
}